export default "__VITE_ASSET__bg_m53TC__"